import { Container } from "@/components/ui/Container";

/**
 * Sub-page hero for the listing routes — a full-width background photo with a
 * dark overlay and a centered white title, mirroring the reference's
 * `section-hero-3`. The marketing header overlays this section (fixed +
 * transparent → white on scroll), so the top padding clears the header.
 */
export function ListingHero({ title, tagline }: { title: string; tagline?: string }) {
  return (
    <section
      className="relative bg-cover bg-center text-white"
      style={{ backgroundImage: "url('/hero/listing.png')" }}
    >
      <div aria-hidden className="absolute inset-0 bg-black/30" />
      <Container className="relative pt-28 md:pt-40 pb-12 md:pb-20 text-center">
        <h1 className="!text-white !text-4xl md:!text-5xl !font-extrabold !tracking-tight !leading-[1.08]">
          {title}
        </h1>
        {tagline ? (
          <p className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed">
            {tagline}
          </p>
        ) : null}
      </Container>
    </section>
  );
}
